import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { I18nProvider } from "./i18n";

import PublicLayout from "./components/PublicLayout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Auth from "./pages/Auth";
import Wishlist from "./pages/Wishlist";
import Dashboard from "./pages/Dashboard";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminPlans from "./pages/admin/AdminPlans";
import AdminCodes from "./pages/admin/AdminCodes";
import Membership from "./pages/Membership";
import {
  AdminOrders, AdminUsers, AdminCategories, AdminCoupons, AdminBanners, AdminStub
} from "./pages/admin/AdminPages";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton theme="light" />
            <Routes>
              {/* Auth without layout */}
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />

              {/* Public layout */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/search" element={<Catalog />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/dashboard/*" element={<Dashboard />} />
              </Route>

              {/* Admin */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="codes" element={<AdminCodes />} />
                <Route path="plans" element={<AdminPlans />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="reviews" element={<AdminStub title="Reviews" description="Manage product reviews and ratings." />} />
                <Route path="gift-cards" element={<AdminStub title="Gift Cards" description="Filter products of type gift_card from Products page." />} />
                <Route path="subscriptions" element={<AdminStub title="Assinaturas" description="Filter products of type subscription from Products page." />} />
                <Route path="premium-accounts" element={<AdminStub title="Contas Premium" description="Filter products of type premium_account from Products page." />} />
                <Route path="notifications" element={<AdminStub title="Notificações" description="Send announcements and email blasts (coming soon)." />} />
                <Route path="transactions" element={<AdminStub title="Transações" description="Stripe payment transactions overview (orders page shows live data)." />} />
                <Route path="reports" element={<AdminStub title="Relatórios" description="Detailed reports — coming soon." />} />
                <Route path="settings" element={<AdminStub title="Configurações" description="Store-wide settings — coming soon." />} />
                <Route path="integrations" element={<AdminStub title="Integrações" description="Stripe (test mode) is active. Connect more providers soon." />} />
                <Route path="permissions" element={<AdminStub title="Permissões" description="Role-based access control (admin role only)." />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
